
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code6 } from "@/views/resources/documentation/element-ui/basic/button/code";

export default defineComponent({
  name: "loading-button",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code6
    };
  }
});
